import { useFormContext, Controller, FieldValues, Path } from 'react-hook-form';
import { TextField as RadixTextField } from '@radix-ui/themes';
import { TextInputConfig } from '../../types';
import { FieldWrapper } from '../FieldWrapper';

export const TextField = <TFormValues extends FieldValues>({
    config,
}: {
    config: TextInputConfig<TFormValues>;
}) => {
    const { control } = useFormContext<TFormValues>();

    return (
        <FieldWrapper config={config}>
            <Controller
                name={config.name as Path<TFormValues>}
                control={control}
                rules={config.validation}
                render={({ field }) => (
                    <RadixTextField.Root
                        type={config.type === 'date' ? 'date' : 'text'}
                        placeholder={config.placeholder}
                        value={field.value ?? ''}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                    />
                )}
            />
        </FieldWrapper>
    );
};
